import { QueryKey } from '@tanstack/react-query';

export const RAFFLE_WEB3_QUERY_KEY = 'RAFFLE_WEB3_QUERY_KEY';

export const getQueryKey = (...args: QueryKey): QueryKey => {
  return [RAFFLE_WEB3_QUERY_KEY, ...args];
};
